"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Preview/components/Caption.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Locale_template = require("../../../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    Price_template = require("../../../../components/Price/index.marko"),
    Price_tag = marko_loadTag(Price_template),
    Row_template = require("../../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    DifficultyLevel_template = require("../../../components/DifficultyLevel.marko"),
    DifficultyLevel_tag = marko_loadTag(DifficultyLevel_template),
    marko_attrs0 = {
        "class": "card my-1"
      },
    marko_attrs1 = {
        "class": "card-content"
      },
    marko_attrs2 = {
        "class": "list-group"
      },
    marko_attrs3 = {
        "class": "list-group-item only-dark-bg-fade border-bottom"
      },
    marko_attrs4 = {
        "class": "list-group-item only-dark-bg-fade border-bottom"
      },
    marko_attrs5 = {
        "class": "list-group-item only-dark-bg-fade border-bottom"
      },
    marko_attrs6 = {
        "class": "list-group-item only-dark-bg-fade border-bottom"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("d7e5f0"),
    marko_node0 = marko_createElement("i", {
        "class": "bx bx-purchase-tag-alt mr-4"
      }, "6", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs7 = {
        "class": "list-group-item only-dark-bg-fade border-bottom"
      },
    marko_node1 = marko_createElement("i", {
        "class": "bx bx-package mr-4"
      }, "13", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs8 = {
        "class": "list-inline m-0"
      },
    marko_attrs9 = {
        "class": "px-25"
      },
    marko_attrs10 = {
        "class": "chip theme-bg-lighten"
      },
    marko_attrs11 = {
        "class": "chip-body font-small-5"
      },
    marko_attrs12 = {
        "class": "chip-text py-25"
      },
    marko_attrs13 = {
        "class": "list-group-item only-dark-bg-fade border-bottom"
      },
    marko_node2 = marko_createElement("i", {
        "class": "bx bxs-school mr-4"
      }, "23", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node3 = marko_createElement("i", {
        "class": "bx bx-label mr-4"
      }, "30", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node4 = marko_createElement("i", {
        "class": "bx bx-star mr-4"
      }, "37", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node5 = marko_createElement("i", {
        "class": "bx bx-world mr-4"
      }, "44", null, 0, 0, {
        i: marko_const_nextId()
      });

function render(input, out, __component, component, state) {
  var data = input;

  out.be("div", marko_attrs0, "0", component);

  out.be("div", marko_attrs1, "1", component);

  out.be("ul", marko_attrs2, "2", component);

  if (input.price && input.price.amount) {
    out.be("li", marko_attrs6, "3", component);

    Row_tag({
        class: "no-gutters",
        col: [
            {
                class: "col-5 d-flex align-items-center",
                renderBody: function(out) {
                  out.n(marko_node0, component);

                  out.t(" ");

                  Locale_tag({
                      text: "Price"
                    }, out, __component, "7");
                }
              },
            {
                renderBody: function(out) {
                  const user = GState.get('user')

                  Price_tag({
                      amount: input.price.amount,
                      currency: input.price.currency,
                      crossout: (((user && user.subscription) && user.subscription.type) && Array.isArray(input.packages)) && input.packages.includes(user.subscription.type)
                    }, out, __component, "9");
                }
              }
          ]
      }, out, __component, "4");

    out.ee();
  }

  if (Array.isArray(input.packages) && input.packages.length) {
    out.be("li", marko_attrs7, "10", component);

    Row_tag({
        class: "no-gutters",
        col: [
            {
                class: "col-5 d-flex align-items-center",
                renderBody: function(out) {
                  out.n(marko_node1, component);

                  out.t(" ");

                  Locale_tag({
                      text: "Packages"
                    }, out, __component, "14");
                }
              },
            {
                renderBody: function(out) {
                  out.be("ul", marko_attrs8, "16", component);

                  marko_forOf(input.packages, function(each, index) {
                    var $keyValue$0 = "@" + index,
                        $keyScope$0 = "[" + ($keyValue$0 + "]");

                    out.e("li", marko_attrs9, $keyValue$0, component, 1)
                      .e("div", marko_attrs10, "17" + $keyScope$0, component, 1)
                        .e("div", marko_attrs11, "18" + $keyScope$0, component, 1)
                          .e("span", marko_attrs12, "19" + $keyScope$0, component, 1)
                            .t(each.toCapitalCase(), component);
                  });

                  out.ee();
                }
              }
          ]
      }, out, __component, "11");

    out.ee();
  }

  if (input.tenant) {
    out.be("li", marko_attrs13, "20", component);

    Row_tag({
        class: "no-gutters",
        col: [
            {
                class: "col-5 d-flex align-items-center",
                renderBody: function(out) {
                  out.n(marko_node2, component);

                  out.t(" ");

                  Locale_tag({
                      text: "Institution"
                    }, out, __component, "24");
                }
              },
            {
                renderBody: function(out) {
                  out.e("span", null, "26", component, 1)
                    .t(input.tenant, component);
                }
              }
          ]
      }, out, __component, "21");

    out.ee();
  }

  out.be("li", marko_attrs3, "27", component);

  Row_tag({
      class: "no-gutters",
      col: [
          {
              class: "col-5 d-flex align-items-center",
              renderBody: function(out) {
                out.n(marko_node3, component);

                out.t(" ");

                Locale_tag({
                    text: "Subject"
                  }, out, __component, "31");
              }
            },
          {
              renderBody: function(out) {
                out.e("span", null, "33", component, 1)
                  .t(input.categories && input.categories[0] ? input.categories[0].name : "Unknown", component);
              }
            }
        ]
    }, out, __component, "28");

  out.ee();

  out.be("li", marko_attrs4, "34", component);

  Row_tag({
      class: "no-gutters",
      col: [
          {
              class: "col-5 d-flex align-items-center",
              renderBody: function(out) {
                out.n(marko_node4, component);

                out.t(" ");

                Locale_tag({
                    text: "Level"
                  }, out, __component, "38");
              }
            },
          {
              renderBody: function(out) {
                DifficultyLevel_tag({
                    type: input.difficultyLevel,
                    onlyvalue: true
                  }, out, __component, "40");
              }
            }
        ]
    }, out, __component, "35");

  out.ee();

  out.be("li", marko_attrs5, "41", component);

  Row_tag({
      class: "no-gutters",
      col: [
          {
              class: "col-5 d-flex align-items-center",
              renderBody: function(out) {
                out.n(marko_node5, component);

                out.t(" ");

                Locale_tag({
                    text: "Multi-Language"
                  }, out, __component, "45");
              }
            },
          {
              renderBody: function(out) {
                Locale_tag({
                    text: input.multiLanguage ? "Yes" : "No"
                  }, out, __component, "47");
              }
            }
        ]
    }, out, __component, "42");

  out.ee();

  out.ee();

  out.ee();

  out.ee();
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
